import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";

/* eslint-disable camelcase */
import React from 'react';
import { Link } from 'react-router-dom';
import { TableActions } from 'components';
import { detailsBtn } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";
export var partnerListColumns = [{
  name: 'ID',
  render: function render(partner) {
    return ___EmotionJSX(Link, {
      to: {
        pathname: "partner/details/".concat(partner === null || partner === void 0 ? void 0 : partner.id),
        state: {
          partner: partner
        }
      }
    }, partner === null || partner === void 0 ? void 0 : partner.id);
  },
  width: '60px'
}, {
  name: 'Име',
  value: 'name'
}, {
  name: 'Адрес',
  value: 'address'
}, {
  name: 'ЕИК',
  value: 'eik'
}, {
  name: 'МОЛ',
  value: 'mol'
}, {
  name: 'Тип на МОЛ',
  value: 'mol_type'
}, {
  name: 'Телефон',
  value: 'phone'
}, {
  name: 'Имейл',
  value: 'email'
}, {
  name: 'Факс',
  value: 'fax'
}, {
  name: 'Комисионна',
  render: function render(_ref) {
    var home_visit_fee_commission_percent = _ref.home_visit_fee_commission_percent;
    return ___EmotionJSX("span", null, home_visit_fee_commission_percent, "%");
  }
}, {
  name: '',
  render: function render(partner) {
    return ___EmotionJSX(TableActions, {
      mainAction: {
        linkTo: {
          pathname: "/partner/details/".concat(partner === null || partner === void 0 ? void 0 : partner.id),
          state: {
            partner: partner
          }
        },
        leftIcon: {
          iconName: 'la la-info',
          size: 20
        },
        css: detailsBtn
      }
    });
  },
  width: '50px'
}].filter(Boolean);